import { getStorage, ref, uploadBytesResumable } from 'firebase/storage'

const VOICE_UPLOAD_TIMEOUT_MS = 30_000

// Storage retries a dropped upload for 10 min and resumes it when the network returns: bound it like the app does, so
// the clip fails back to its preview instead of leaving later on its own.
export const uploadVoiceClip = async (storagePath: string, blob: Blob) => {
  if (!navigator.onLine) throw new Error('Voice clip not sent, the browser is offline')
  const upload = uploadBytesResumable(ref(getStorage(), storagePath), blob, { contentType: 'audio/mp4' })
  const cancel = () => upload.cancel()
  const timeout = globalThis.setTimeout(cancel, VOICE_UPLOAD_TIMEOUT_MS)
  try {
    await upload
  } finally {
    globalThis.clearTimeout(timeout)
  }
  return storagePath
}
